import React from 'react';
import utils from '../../utils';
import fetch from '../fetch';

import { Modal, message, Radio, Checkbox, Input, Tag } from 'antd';

const DataGrid = {
    selections: [],
    selectData: [],
    refresh: function() {

    }
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelectData = (data) => {
    DataGrid.selectData = data;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids
}

const getSelection =() => {
    return DataGrid.selections;
}

const headers = utils.columns(
    [
        {type: 'selection'},
        {   
            key:'$index', 
            label: '序号',
            width: 80
        },
        {
            key: 'schoolName',
            label: '学校',
            width: 150
        },
        {
            key: 'superDepartment',
            label: '上级主管部门',
            width: 120
        },
        {
            key: 'organization',
            label: '机构名称',
            width: 125
        },
        {
            key:'approvalStatus', 
            label: '审核状态',
            width: 120,
            render: (val) => {
                if(val === 0) {
                    return <Tag color="blue">待审核</Tag>
                } else if(val === 1) {
                    return <Tag color="green">审核通过</Tag>
                } else if(val === 2) {
                    return <Tag color="red">审核不通过</Tag>
                }else{
                    return <Tag color="blue">待审核</Tag>
                }
            }
        },
        {
            key:'approvalTime', 
            label: '审核时间',
            width: 120
        }
    ]
)

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    if(keywords['sort'] !== '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('/ciqamembercollectinfo/query?' + params.join('&'), keywords)
    .then((response) => {
        if(response.code === 200) {
            return response.payload.data;
        }
    }).then(data => (
        Object.assign({
            result: data.dataList || [],
            selects: (data.dataList || []).map(d => ({
                value: d.id,
                checked: false,
            })),
            checked: false,
            total: data.total,
            pageIndex: data.pageNum,
            pageSize: data.pageSize,
            notify: (data.dataList || []).length ? '' : '暂无数据...'
        }))
    )
}
const queryById = (id) => {
    //return fetch.mockget
}

export default {
    headers,
    onSelect,
    onSelectData,
    setRefresh,
    getSelection,
    querySearch,
    queryById
}